import { DateTimeStamp } from '../../../types/dateTime';

export const getCurrentMonthLabel = () => new Date().toLocaleString('default', { month: 'short' });

export const getNextMonthLabel = () => {
  const now = new Date();
  const nextMonth = now.getMonth() === 11
    ? new Date(now.getFullYear() + 1, 0)
    : new Date(now.getFullYear(), now.getMonth() + 1);

  return nextMonth.toLocaleString('default', { month: 'short' });
};

/**
 * Return a new Date object from a string with format YYYY-MM
 * @param dateString a date string with the form YYYY-MM
 * @returns Date object
 */
export const getDateFromYYYYMM = (dateString: string) => {
  const year = Number(dateString.slice(0, 4));
  // Javascript months are zero indexed
  const month = Number(dateString.slice(5)) - 1;

  return new Date(year, month);
};

/**
 * Return the short form label for the month
 * @param dateString - a date with the format YYYY-MM
 * @returns short form label of the date's month (eg Jan, Feb, Mar, etc)
 */
export const getMonthLabel = (date: Date) => (
  new Date(date.getFullYear(), date.getMonth()).toLocaleString('default', { month: 'short' })
);

/**
 * Returns the last day of the current month, accounting for things like leap year
 * @returns number: the last day of the current month
 */
export const getLastDayOfMonth = (date: Date = new Date()) => (
  // Getting next month's "day 0" returns the last day of this month
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
);

/**
 * Returns the current month and year in format expected for Top Pro data
 * @returns string: the current year and month in format YYYY-MM
 */
export const getCurrentMonthFormatted = () => {
  const now = new Date();
  const year = now.toLocaleString('default', { year: 'numeric' });
  const month = now.toLocaleString('default', { month: '2-digit' });
  return `${year}-${month}`;
};

export const daysSince = (dateTime: DateTimeStamp) => {
  const diff = Math.abs(Date.now() - new Date(dateTime).getTime());
  return Math.floor(diff / 86400000);
};
